<template>
    <div dir="rtl" class="modal fade ai-help-modal qbank-section" id="help-modal" tabindex="-1" role="dialog"
        aria-labelledby="aiHelpModalTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <input type="hidden" id="questionHelpId">

                <div class="modal-header d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                        <h5 class="modal-title" id="aiHelpModalTitle">علّمني كيف</h5>
                    </div>
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                        <i class="fa fa-close"></i> إغلاق
                    </button>
                </div>

                <div class="modal-body text-center">
                    <div class="mb-3">
                        <img src="assets/img/chat.png" alt="AI Help Icon" class="modal-icon"
                            style="width: 100px; height: 100px;">
                    </div>

                    <div v-if="isLoading" class="text-center my-4">
                        <div class="spinner-border text-success" role="status">
                            <span class="visually-hidden">جارٍ التحميل...</span>
                        </div>
                        <div class="mt-2">جاري جلب الشرح، الرجاء الانتظار...</div>
                    </div>

                    <div v-else>
                        <div v-if="!started" class="text-center">
                            <button class="btn btn-success btn-lg rounded-pill"
                                style="padding: 10px 40px;background-color: #1e318d;" @click="startExplanation">
                                <i class="fa fa-play ms-2"></i> ابدأ
                            </button>
                        </div>

                        <div v-else>
                            <h5 class="text-success mb-3">{{ steps[currentStep - 1].title }}</h5>
                            <div class="mb-3 text-center">
                                <strong>خطوة {{ currentStep }} من 4</strong>
                            </div>
                            <div class="mb-3">
                                <p :dir="isEnglish ? 'ltr' : 'rtl'" :class="isEnglish ? 'text-end' : 'text-start'"
                                    class="ai-step-text bg-light p-3 rounded border">
                                    <span v-for="(char, index) in displayedText" :key="index">{{ char }}</span>
                                </p>
                            </div>

                            <div class="d-flex justify-content-between mt-4">
                                <button v-if="currentStep > 1" class="btn btn-outline-secondary rounded-pill px-4"
                                    @click="prevStep">
                                    <i class="fa fa-arrow-right me-2"></i> السابق
                                </button>
                                <div></div>
                                <button v-if="currentStep < 4" class="btn btn-success rounded-pill px-4"
                                    @click="nextStep">
                                    التالي <i class="fa fa-arrow-left ms-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { apiUrl } from "@/utils/api";

export default {
    name: "HelpAiModal",
    data() {
        return {
            token: localStorage.getItem("access_token"),
            currentStep: 1,
            stepText: '',
            guidance: '',
            isLoading: false,
            started: false,
            displayedText: '',
            isEnglish: false,
            steps: [
                { title: "فهم السؤال" },
                { title: "تحليل المشكلة" },
                { title: "تقييم الخيارات" },
                { title: "شرح الجواب الصحيح" }
            ]
        }
    },
    methods: {
        async getStepText() {
            const questionId = document.getElementById("questionHelpId").value;
            if (!questionId) return;

            this.isLoading = true;
            this.stepText = '';
            try {
                const response = await fetch(`${apiUrl}/qbanks/questions/${questionId}/ai-guidance`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${this.token}`,
                    },
                    body: JSON.stringify({
                        current_step: this.currentStep,
                        student_answer: ""
                    })
                });

                const data = await response.json();

                if (!this.guidance) {
                    this.guidance = data.guidance || '';
                }

                this.stepText = data.guidance || 'لا يوجد شرح حالياً.';

                let cleanedText = this.stepText.replace(/[^\x00-\x7F]/g, '');

                // 2️⃣ إزالة المسافات غير المرئية والرموز الغريبة
                cleanedText = cleanedText.replace(/[\u200B-\u200D\uFEFF]/g, '').trim();

                // 3️⃣ التحقق إذا كان هناك أي حرف عربي في النص، إذا وُجد نُرجع false مباشرةً
                const hasArabic = /[\u0600-\u06FF]/.test(this.stepText);

                // 4️⃣ التحقق إذا كان النص المتبقي إنجليزيًا فقط، مع السماح بالرموز الجديدة
                this.isEnglish = /^[A-Za-z0-9.,;!?():\s\-\*\"\'\n•]*$/.test(cleanedText) && !hasArabic;

                // 5️⃣ عرض أي رموز غير متوقعة إذا كان التحقق فشل
                if (!this.isEnglish) {
                    console.log("❌ Non-English Characters Detected:", cleanedText.match(/[^A-Za-z0-9.,;!?():\s\-\*\"\'\n•]/g));
                }

                console.log("Cleaned Text:", cleanedText);
                console.log("Is English:", this.isEnglish);
                this.typingEffect();
            } catch (err) {
                console.error("AI Guidance Error:", err);
                this.stepText = 'حدث خطأ أثناء جلب الشرح.';
            } finally {
                this.isLoading = false;
            }
        },
        typingEffect() {
            this.displayedText = '';
            let index = 0;
            const interval = setInterval(() => {
                if (index < this.stepText.length) {
                    this.displayedText += this.stepText[index];
                    index++;
                } else {
                    clearInterval(interval);
                }
            }, 20);
        },
        startExplanation() {
            this.started = true;
            this.getStepText();
        },
        nextStep() {
            if (this.currentStep < 4) {
                this.currentStep++;
                this.getStepText();
            }
        },
        prevStep() {
            if (this.currentStep > 1) {
                this.currentStep--;
                this.getStepText();
            }
        }
    }
}
</script>

<style scoped>
.ai-help-modal .modal-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
}

.ai-help-modal .modal-body {
    padding: 1.5rem;
}

.ai-help-modal .ai-step-text {
    font-size: 1.1rem;
    line-height: 1.8;
    color: #333;
    white-space: pre-line;
}

.modal-icon {
    width: 60px;
    height: 60px;
    object-fit: contain;
    margin-top: -20px;
}

.modal-icon {
    display: block;
    margin: 0 auto;
    animation: pulse 1.8s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
        opacity: 0.8;
    }

    50% {
        transform: scale(1.1);
        opacity: 1;
    }

    100% {
        transform: scale(1);
        opacity: 0.8;
    }
}

.ai-step-text {
    font-size: 1.1rem;
    line-height: 1.8;
    white-space: pre-line;
}
</style>
